<template>
  <v-container fluid>

    <TableItems
        ref="table_scadenze"
        model-name-prop="Scadenza"
        :sort_by="['Data']"
        :loadItemsOnCreated="false"
        :showTopToolbar="true"
        :show-title="false"
        :show-refresh-btn="false"
        :show-new-btn="false"
    >
      <!-- /**/-->
      <template slot="mj_speed_dial_buttons" slot-scope="data">

        <v-tooltip bottom v-if='data.selected.length > 0'>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                fab
                x-small
                color="red white--text"
                class="ml-2"
                @click="syncGCal"
            >
              <v-icon>mdi-calendar-arrow-right</v-icon>
            </v-btn>
          </template>
          <span>Invia a G.Cal</span>
        </v-tooltip>
        <v-tooltip bottom v-if='data.selected.length > 0'>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                fab
                x-small
                color="green white--text"
                class="ml-2"
                @click="concludiScadenze"
            >
              <v-icon>mdi-check-all</v-icon>
            </v-btn>
          </template>
          <span>Segna come Conclusa</span>
        </v-tooltip>

      </template>
      <template slot="mj_top_toolbar_prepend" slot-scope="data">
        <v-tooltip bottom v-if='data.selected.length > 0'>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                fab
                x-small
                color="red white--text"
                class="ml-2"
                @click="syncGCal"
            >
              <v-icon>mdi-calendar-arrow-right</v-icon>
            </v-btn>
          </template>
          <span>Invia a G.Cal</span>
        </v-tooltip>
        <v-tooltip bottom v-if='data.selected.length > 0'>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
                v-bind="attrs"
                v-on="on"
                fab
                x-small
                color="green white--text"
                class="ml-2"
                @click="concludiScadenze"
            >
              <v-icon>mdi-check-all</v-icon>
            </v-btn>
          </template>
          <span>Segna come Conclusa</span>
        </v-tooltip>
      </template>
      <template slot="mj_filters_section">

        <MjFilterGroup
            ref="filter_group"
            :expand_filter="true"
            class="mt-0 px-2"
            @reset-all="
            $refs.table_scadenze.filters = [];
            $refs.table_scadenze.loadItems(true);
          "
        >

          <template slot="filters" slot-scope="props">

            <v-row align="center">
              <v-col cols="6">
                <MjComboBoxFilter
                    label="Responsabile"
                    load_items_url="/api/list/User/UserResource4SelectCollection"
                    filter_name="User"
                    relation_field_name="users.id"
                    :item_description_field="(item) => `${item.name} - ${item.email}`"
                    item_value_field="id"
                    glue="and"
                    :priority="1"
                    @change="updateFilters"
                    :silent_reset="props.reset_all"
                />
              </v-col>
              <v-col cols="6">
                <MjToggleFilter
                    label="Stato Prenotazione"
                    small
                    :items_prop="[{description:'Da Fare',value:0}, {description:'Conclusa', value:1}]"
                    filter_name="scadenze.stato"
                    :item_description_field="(item) => `${item.description}`"
                    item_value_field="value"
                    glue="and"
                    :priority="2"
                    :multiple="false"
                    @change="updateFilters"
                    :silent_reset="props.reset_all"
                    :selected_prop="0"
                />
              </v-col>
            </v-row>
          </template>
        </MjFilterGroup>

      </template>
    </TableItems>
  </v-container>
</template>
<style>
</style>

<script>
import TableItems from "@/views/TableItems.vue";
import MjToggleFilter from "@/components/filters/MjToggleFilter.vue";
import MjComboBoxFilter from "@/components/filters/MjComboBoxFilter.vue";
import MjFilterGroup from "@/components/filters/MjFilterGroup.vue";
import mj_axios from "@/mj_axios";


export default {
  components: {TableItems, MjFilterGroup, MjToggleFilter, MjComboBoxFilter},

  computed: {},
  data: () => (
      {
        first_load: true //usato per determinare il primo caricamento. Alla fine del primo chiudo l'expansion dei filtri (lo devo tenere aperto al caricamento per consentire gli emit con i nuovi valori dei filtri..)
        //soluzione rapida, da migliorare.
      }),


  methods: {
    /*function replicata anche su schedapratica, se aggiorni cambia anche li o centralizza la function*/
    concludiScadenze: function () {
      if (
          this.$refs.table_scadenze.selected == null ||
          this.$refs.table_scadenze.selected.length == 0
      ) {
        this.snack_bar_show = true;
        this.error_text = `Non hai scelto alcuna riga..`;
      } else {
        this.loading_overlay = true;
        this.error_show = false;

        let params = {ids: this.$refs.table_scadenze.selected_ids};
        const axios_promise = mj_axios.post("/api/concludi_scadenze", params); //insert

        axios_promise
            .then(() => {
              this.$refs.table_scadenze.selected = [];
              this.$refs.table_scadenze.loadItems(false);
            })

            .catch((e) => {
              // const status = e.response ? e.response.status : null;
              let message =
                  e.response && e.response.data ? e.response.data.message : null;

              this.error_show = true;
              this.error_text = `Errore nel Salvataggio dati  ${
                  message ? message : ""
              }`;
            })
            .then(() => {
              this.loading_overlay = false;
            });
      }
    },
    /*funzione presente anche su schedapratica centralizza o se modifichi cambia anche lì*/
    syncGCal: function () {
      this.loading_overlay = true;
      this.error_show = false;

      let params = {ids: this.$refs.table_scadenze.selected_ids};
      const axios_promise = mj_axios.post("/api/sync_gcal_scadenze", params);

      axios_promise
          .then(() => {
            this.$refs.table_scadenze.loadItems(false);
          })

          .catch((e) => {
            // const status = e.response ? e.response.status : null;
            let message =
                e.response && e.response.data ? e.response.data.message : null;

            this.error_show = true;
            this.error_text = `Errore nella Sincronizzazione dati  ${
                message ? message : ""
            }`;
          })
          .then(() => {
            this.loading_overlay = false;
          });
    },

    updateFilters: function (data) {


      this.$nextTick(() => {
        // The whole view is rendered, so I can safely access or query
        // the DOM. ¯\_(ツ)_/¯
        this.$refs.table_scadenze.updateFilters(data);
        if (this.first_load) {
          this.first_load = false;
          this.$refs.filter_group.collapsePanels();
        }
      })


    },
  },

};
</script>


